import React, { useState } from 'react';

interface CollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    marginBottom: '1rem',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.75rem 1.25rem',
    cursor: 'pointer',
    backgroundColor: '#f9fafb',
    borderBottom: '1px solid #e0e0e0',
    transition: 'background-color 0.15s',
  },
  headerCollapsed: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.75rem 1.25rem',
    cursor: 'pointer',
    backgroundColor: '#f9fafb',
    borderBottom: 'none',
    transition: 'background-color 0.15s',
  },
  title: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#0f2d1f',
    margin: 0,
  },
  toggle: {
    fontSize: '1rem',
    color: '#666',
    transition: 'transform 0.2s',
  },
  content: {
    padding: '0',
  },
};

export function CollapsibleSection({ title, defaultOpen = false, children }: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div style={styles.container}>
      <div
        style={isOpen ? styles.header : styles.headerCollapsed}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 style={styles.title}>{title}</h3>
        <span style={{ ...styles.toggle, transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          ▼
        </span>
      </div>
      {isOpen && (
        <div style={styles.content}>
          {children}
        </div>
      )}
    </div>
  );
}
